module.exports = __webpack_public_path__ + "static/media/feedback-bw.6b2b7180.svg";